// extracted by mini-css-extract-plugin
export default {"base":"Dropdown_base__3CYX3","body":"Dropdown_body__IdtsT","App":"Dropdown_App__8iiFC","dropdown":"Dropdown_dropdown__zucWS"};